import React, { Component } from "react";
import { DKButton } from "deskera-ui-library";
import Incrementor from "../../common/Incrementor";

/*
PROPS
- data // this is current components data
- onDataChange
- className
*/

class WidthEditor extends Component {
  constructor(props) {
    super(props);
    this.componentData = this.props.data;
  }
  render() {
    return (
      <div className={"parent-width " + this.props.className}>
        <div className="row">
          <Incrementor
            title="Width"
            value={this.getParesedWidth(this.props.data.style.width)}
            onChange={this.changeWidth}
            UOM="%"
          />
          <DKButton
            title="A"
            className="bg-gray1 border-m ml-s"
            onClick={() => {
              this.changeWidth("auto");
            }}
          />
          <DKButton
            title="F"
            className="bg-gray1 border-m ml-s"
            onClick={() => {
              this.changeWidth("100");
            }}
          />
        </div>
      </div>
    );
  }

  //Remove % and send or fit-content to auto
  getParesedWidth(width) {
    if (width === "fit-content") {
      return "auto";
    }
    if (width.includes("%")) {
      return Number(width.substring(0, width.length - 1));
    }
    return width;
  }

  changeWidth = (value) => {
    let style = { ...this.componentData.style };
    if (value === "auto") {
      style.width = "fit-content";
    } else {
      style.width = value + "%";
    }

    this.componentData.style = style;
    this.props.onDataChange(this.componentData);
  };
}

export default WidthEditor;
